import { render } from "./MailingBlockButton.vue?vue&type=template&id=c47b717e"
import script from "./MailingBlockButton.vue?vue&type=script&lang=js"
export * from "./MailingBlockButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__